import { clsx } from 'clsx'
import type { InputHTMLAttributes } from 'react'
import { forwardRef } from 'react'
import * as styles from './index.css'

interface ToggleSwitchProps extends InputHTMLAttributes<HTMLInputElement> {
  checked: boolean
}

export const ToggleSwitch = forwardRef<HTMLInputElement, ToggleSwitchProps>(
  (props, ref) => {
    return (
      <label className={styles.toggleContainer}>
        <input
          type='checkbox'
          className={styles.visuallyHiddenCheckbox}
          ref={ref}
          {...props}
        />
        <span
          className={clsx(
            styles.toggleBackground,
            styles.toggleBackgroundVariant[props.checked ? 'on' : 'off'],
          )}
        />
        <span
          className={clsx(
            styles.toggleCircle,
            styles.toggleCircleVariant[props.checked ? 'on' : 'off'],
          )}
        />
      </label>
    )
  },
)
